 import { combineReducers } from "redux";
import BasicModeReducer from "./BasicModeReducer";
import SidebarActiveButtonReducer from "./SidebarActiveButtonReducer";
import CommonReducer from "./CommonReducer";
import AreaSelectionModeReducer from "./AreaSelectionModeReducer";
 export default combineReducers({
      BasicModeReducer,
      SidebarActiveButtonReducer,
      CommonReducer,
      AreaSelectionModeReducer
 })